module.exports = __webpack_public_path__ + "static/media/Xenon1952.f27c454a.png";